export const REFUEL_STATUS = {
  READY: "ready",
  PENDING: "pending",
  COMPLETE: "complete",
};

export const API_ENDPOINTS = {
  kiosk: {
    connect: "/kiosk/connect",
  },
  user: {
    login: "/user/login",
    verify: "/user/verify",
    signup: "/user/signup",
    profile: "/user/profile",
    delete: "/user/delete",
    update: "/user/update",
    resetPassword: "/user/reset/password",
    resetPhone: "/user/reset/phone",
    findPassword: "/user/find/password",
    findAccount: "/user/find/account",
    refresh: "/user/refresh",
    updateAutoLogin: "/user/update/autologin",
  },
  sales: {
    history: "/sales/history",
    getAllUsage: "/sales/usage",
    receipt: "/sales/receipt"
  },
  message: {
    sendSMSForSignup: "/message/send/sms/signup",
    sendSMSForFindAccount: "/message/send/sms/find/account",
    verifySMS: "/message/verify/sms",
    sendSMSToUser: "/message/send/sms/user",
  },
  setting: {
    get: "/setting/get",
    setPushMarketing: "/setting/push/marketing",
    setPushNotice: "/setting/push/notice",
  },
  outlet: {
    address: "/outlet/address",
  },
  home: {
    stationDetail: "/home/station/detail",
  },
};

export const API_URL = {
  TERMS_URL: window.location.origin + "/termsofservice/index.html",
  PRIVACY_URL: window.location.origin + "/privacypolicy/index.html",
};

export const CONTACTS = {
  KAKAO: process.env.REACT_APP_CONTACT_KAKAO_CHANNEL_LINK,
  TEL: process.env.REACT_APP_CONTACT_TEL
}